import { createRouter, createWebHistory } from 'vue-router'
import { ElMessage } from 'element-plus'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/LoginView.vue'),
    meta: { public: true }
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import('../views/ForgotPasswordView.vue'),
    meta: { public: true }
  },
  {
    path: '/reset-password/:token',
    name: 'ResetPassword',
    component: () => import('../views/ResetPasswordView.vue'),
    meta: { public: true }
  },
  {
    path: '/',
    name: 'Layout',
    component: () => import('../views/LayoutView.vue'),
    redirect: '/ai-image',
    children: [
      {
        path: '/ai-image',
        name: 'AIImage',
        component: () => import('../views/AIImageView.vue')
      },
      {
        path: '/ai-video',
        name: 'AIVideo',
        component: () => import('../views/AIVideoView.vue')
      },
      {
        path: '/batch-image',
        name: 'BatchImage',
        component: () => import('../views/BatchImageView.vue')
      },
      {
        path: '/workflow',
        name: 'WorkflowList',
        component: () => import('../views/workflow/WorkflowListView.vue')
      },
      {
        path: '/workflow/:id',
        name: 'WorkflowCanvas',
        component: () => import('../views/workflow/WorkflowCanvasView.vue')
      },
      {
        path: '/gallery',
        name: 'Gallery',
        component: () => import('../views/GalleryView.vue')
      },
      {
        path: '/roi-calculator',
        name: 'ROICalculator',
        component: () => import('../views/ROICalculatorView.vue')
      },
      {
        path: '/recently-deleted',
        name: 'RecentlyDeleted',
        component: () => import('../views/RecentlyDeletedView.vue')
      },
      {
        path: '/consumption',
        name: 'Consumption',
        component: () => import('../views/ConsumptionView.vue')
      },
      {
        path: '/knowledge',
        name: 'Knowledge',
        component: () => import('../views/KnowledgeView.vue')
      },
      {
        path: '/meme-search',
        name: 'MemeSearch',
        component: () => import('../views/MemeSearchView.vue')
      },
      {
        path: '/video-dedup',
        name: 'VideoDedup',
        component: () => import('../views/VideoDedupView.vue')
      },
      {
        path: '/video-removal',
        name: 'VideoRemoval',
        component: () => import('../views/VideoRemovalView.vue')
      },
      {
        path: '/product-detail',
        name: 'ProductDetail',
        component: () => import('../views/ProductDetailView.vue')
      },
      {
        path: '/hot-replica',
        name: 'HotReplica',
        component: () => import('../views/HotReplicaView.vue')
      },
      {
        path: '/douyin-remove',
        name: 'DouyinRemove',
        component: () => import('../views/DouyinRemoveView.vue')
      },
      {
        path: '/profile',
        name: 'Profile',
        component: () => import('../views/ProfileView.vue')
      }
    ]
  },
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: () => import('../admin/AdminLoginView.vue'),
    meta: { public: true }
  },
  {
    path: '/admin',
    component: () => import('../admin/AdminLayout.vue'),
    meta: { requiresAdmin: true },
    children: [
      {
        path: '',
        name: 'AdminDashboard',
        component: () => import('../admin/AdminDashboardView.vue')
      },
      {
        path: 'models',
        name: 'AdminModels',
        component: () => import('../admin/AdminModelsView.vue')
      },
      {
        path: 'users',
        name: 'AdminUsers',
        component: () => import('../admin/AdminUsersView.vue')
      },
      {
        path: 'tasks',
        name: 'AdminTasks',
        component: () => import('../admin/AdminTasksView.vue')
      },
      {
        path: 'announcements',
        name: 'AdminAnnouncements',
        component: () => import('../admin/AdminAnnouncementsView.vue')
      },
      {
        path: 'system/menus',
        name: 'AdminMenus',
        component: () => import('../admin/AdminMenusView.vue')
      },
      {
        path: 'system/settings',
        name: 'AdminSystemSettings',
        component: () => import('../admin/AdminSystemSettingsView.vue')
      },
      {
        path: 'system/version',
        name: 'AdminVersion',
        component: () => import('../admin/AdminVersionView.vue')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAdmin)) {
    const adminToken = localStorage.getItem('admin_token')
    if (!adminToken) {
      next('/admin/login')
      return
    }
    next()
    return
  }
  if (to.meta.public) {
    next()
    return
  }
  const token = localStorage.getItem('token')
  if (!token) {
    ElMessage.warning('请先登录')
    next('/login')
  } else {
    next()
  }
})

export default router
